import * as api from "./api";
import * as modelsGet from "../models/get";
import * as modelsPost from "../models/post";

/**
 * Gibt alle Personen zurück.
 */
export function getPersons(): JQueryPromise<modelsGet.IPerson[]>
{
    var endpoint = new URI("api/persons");

    return api.get<modelsGet.IPerson[]>({
        endpoint: endpoint.href()
    });
}

/**
 * Gibt eine bestimmte Person zurück.
 */
export function getPersonById(id: number): JQueryPromise<modelsGet.IPerson>
{
    var endpoint = new URI("api/persons");
    endpoint.segment(id.toString());

    return api.get<modelsGet.IPerson>({
        endpoint: endpoint.href()
    });
}

/**
 * Gibt alle Besatter zurück.
 */
export function getMorticians(onlyActive: boolean = true): JQueryPromise<modelsGet.IPerson[]>
{
    var endpoint = new URI("api/persons/morticians");
    endpoint.setQuery("onlyActive", (onlyActive) ? "true" : "false");

    return api.get<modelsGet.IPerson[]>({
        endpoint: endpoint.href()
    });
}

/**
 * Gibt alle Pfarrer zurück.
 */
export function getPastors(onlyActive: boolean = true): JQueryPromise<modelsGet.IPerson[]>
{
    var endpoint = new URI("api/persons/pastors");
    endpoint.setQuery("onlyActive", (onlyActive) ? "true" : "false");

    return api.get<modelsGet.IPerson[]>({
        endpoint: endpoint.href()
    });
}

export function getMorticiansPaging(onlyActive: boolean = true, pageNo: number = 1, pageSize: number = 50): JQueryPromise<modelsGet.IPagedResult<modelsGet.IPerson>>
{
    var endpoint = new URI("api/persons/morticians/paging");
    endpoint.setQuery("onlyActive", (onlyActive) ? "true" : "false");
    endpoint.setQuery("pageNo", pageNo.toString());
    endpoint.setQuery("pageSize", pageSize.toString());

    return api.get<modelsGet.IPagedResult<modelsGet.IPerson>>({
        endpoint: endpoint.href()
    });
}

/**
 * Erstellt einen neuen Eintrag.
 * @param jsonData Ein JSON-Objekt mit den Daten die gesendet werden sollen.
 */
export function postMortician(person: modelsPost.IMortician): JQueryPromise<any>
{
    return api.post({
        contentType: "application/json",
        endpoint: "api/persons/mortician",
        data: JSON.stringify(person)
    });
}

/**
 * Erstellt einen neuen Eintrag.
 * @param jsonData Ein JSON-Objekt mit den Daten die gesendet werden sollen.
 */
export function postPastor(person: modelsPost.IPastor): JQueryPromise<any>
{
    return api.post({
        contentType: "application/json",
        endpoint: "api/persons/pastors",
        data: JSON.stringify(person)
    });
}

/**
 * Ändert einen vorhandenen Eintrag.
 * @param id Die ID des Eintrags.
 * @param jsonData Ein JSON-Objekt mit den Daten die gesendet werden sollen.
 */
export function putMortician(id: number, person: modelsPost.IMortician): JQueryPromise<any>
{
    return api.put({
        contentType: "application/json",
        endpoint: `api/persons/mortician/${id}`,
        data: JSON.stringify(person)
    });
}

/**
 * Ändert einen vorhandenen Eintrag.
 * @param id Die ID des Eintrags.
 * @param jsonData Ein JSON-Objekt mit den Daten die gesendet werden sollen.
 */
export function putPastor(id: number, person: modelsPost.IPastor): JQueryPromise<any>
{
    return api.put({
        contentType: "application/json",
        endpoint: `api/persons/pastors/${id}`,
        data: JSON.stringify(person)
    });
}

/**
 * Löscht einen vorhandenen Eintrag.
 * @param id Die ID des Eintrags.
 */
export function removeMortician(id: number): JQueryPromise<any>
{
    return api.remove({
        endpoint: `api/persons/mortician/${id}`
    });
}

/**
 * Löscht einen vorhandenen Eintrag.
 * @param id Die ID des Eintrags.
 */
export function removePastor(id: number): JQueryPromise<any>
{
    return api.remove({
        endpoint: `api/persons/pastors/${id}`
    });
}